(function () {
  function applySwatchImages() {
    if (!window.colorSwatchImages) return;

    document.querySelectorAll('.product-colors button[data-color]').forEach(function (btn) {
      var colorName = btn.getAttribute('data-color');
      var imgUrl = window.colorSwatchImages[colorName];
      if (!imgUrl) return;

      var span = btn.querySelector('.color');
      if (!span) return;

      // すでにimgが入ってたら二重適用しない
      if (span.querySelector('img')) return;

      span.innerHTML = '<img src="' + imgUrl + '" alt="' + (colorName || '') + '"><i></i>';
      span.style.backgroundColor = 'transparent';
      span.classList.add('color--image');
    });
  }

  // 初回
  document.addEventListener('DOMContentLoaded', applySwatchImages);

  // Vue等で後からDOMが差し替わる可能性に備えて監視
  var target = document.querySelector('#vue-product-detail') || document.body;
  if (target && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      applySwatchImages();
    });
    mo.observe(target, { childList: true, subtree: true });
  }
})();
